const indexes = [
  {
    type: 'standard',
    path: 'public_html/wp-admin/includes',
    status: 'enabled',
  },
  {
    type: 'standard',
    path: 'public_html/wp-admin/network',
    status: 'enabled',
  },
  {
    type: 'default',
    path: 'public_html/wp-content',
    status: 'default',
  },
  {
    type: 'standard',
    path: 'public_html/wp-content/mu-plugins',
    status: 'enabled',
  },
  {
    type: 'default',
    path: 'public_html/wp-content/plugins',
    status: 'default',
  },
  {
    type: 'standard',
    path: 'public_html/wp-content/upgrade',
    status: 'enabled',
  },
  {
    type: 'none',
    path: 'public_html/wp-includes',
    status: 'disabled',
  },
  {
    type: 'fancy',
    path: 'public_html/wp-includes/certificates',
    status: 'enabled',
  },
  {
    type: 'fancy',
    path: 'public_html/wp-includes/pomo',
    status: 'enabled',
  },
  {
    type: 'none',
    path: 'public_html/wp-includes/style-engine',
    status: 'disabled',
  },
];

export default indexes;
